import React from 'react';
import { Helmet } from 'react-helmet';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Redirect, RouteComponentProps } from '@reach/router';

import { RootState } from 'store/store';

import messages from './Messages';
import { parse } from 'query-string';
import TaskItemsViewer from '../../Tasks/TasksManagement/TaskItemsViewer';
import { DataContextProvider } from 'store/context/DataContext';
import { setSingleItemAccessToken } from 'store/session/SessionSlice';
import {
  requireDocument,
  requireDocumentFn,
  requireProvider,
  requireProviderFn,
} from 'store/providers/providerSlice';
import LogoLoading from '../../../components/LogoLoading/LogoLoading';
import { getRedirectToLoginLocation } from '../../../utils/happyFunctions';
import { white } from '../../../utils/style/colors';
import { appDispatch } from 'store/store';

interface IStateToProps {
  provider: any;
  openItem?: any;
}

interface IOwnProps {
  providerId?: string;
  itemId?: string;
}
interface IDispatchProps {
  setSingleItemAccessToken: (token: string) => void;
  requireProviderItem: (
    providerItemId: number
  ) => ReturnType<typeof requireDocumentFn>;
  requireProvider: (provider: number) => ReturnType<typeof requireProviderFn>;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  RouteComponentProps &
  IDispatchProps;

interface IContentState {
  loading: boolean;
  redirectHome?: boolean;
}

class DirectContent extends React.PureComponent<
  IComponentProps,
  IContentState
> {
  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const parsed: any = parse(window.location!.search);
    this.props.setSingleItemAccessToken(parsed.token);
    if (this.props.provider === undefined) {
      this.props
        .requireProvider(Number(this.props.providerId) || 0)
        .then(null, (e) => {
          if (e.code >= 400 && e.code < 500)
            window.location.href = getRedirectToLoginLocation();
        });
    }
    if (this.props.openItem === undefined) {
      this.props
        .requireProviderItem(Number(this.props.itemId) || 0)
        .then(
          () => this.setState({ loading: false }),
          (e) => {
            if (e.code >= 400 && e.code < 500)
              window.location.href = getRedirectToLoginLocation();
          }
        )
        .catch((e) => {
          if (e.code >= 400 && e.code < 500)
            window.location.href = getRedirectToLoginLocation();
        });
    } else {
      this.setState({ loading: false });
    }
  }

  onClose = () => {
    // if (this.props.thisUser) this.setState({ redirectHome: true });
    // else
    if (history.length === 1) window.close();
    window.history.back();
  };

  render() {
    const { openItem } = this.props;
    const { redirectHome } = this.state;

    if (redirectHome) return <Redirect to="/homepage" noThrow={true} />;
    if (this.state.loading) {
      return (
        <>
          {' '}
          <LogoLoading background={white} />
        </>
      );
    }
    const filteredResponseId = parse(window.location.search)?.r;
    return (
      <div>
        {/**/}
        <Helmet>
          <title>{messages.contentManagement}</title>
          <meta name="description" content={messages.contentManagement} />
        </Helmet>
        {openItem && openItem.data && (
          <DataContextProvider value={{ providerId: openItem.data.providerId }}>
            <TaskItemsViewer
              dispatch={appDispatch}
              onClose={this.onClose}
              openItem={openItem}
              showHome={true}
              openItemProps={{
                filteredResponseId: filteredResponseId
                  ? Number(filteredResponseId)
                  : undefined,
              }}
            />
          </DataContextProvider>
        )}
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const providerId = Number(props.providerId);
  const itemId = Number(props.itemId);
  const thisUser = state.thisUser;
  const provider = state.providers.map[providerId];
  const openItem = state.providers.items[providerId]?.items[itemId];

  return {
    provider,
    openItem,
    thisUser,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchProps,
  IOwnProps
> = () => ({
  setSingleItemAccessToken: (token: string) =>
    appDispatch(setSingleItemAccessToken(token)),
  requireProviderItem: (providerItemId: number) =>
    appDispatch(requireDocument({ documentId: providerItemId })),
  requireProvider: (providerId: number) =>
    appDispatch(requireProvider({ providerId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DirectContent);
